<template>
    <div>
        <div class="app-title">
            <div>
                <h2>{{ $t("tlt.role.list") }}</h2>
                <ul class="app-breadcrumb breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/"><i class="fa fa-home"></i></router-link></li>
                    <!-- <li class="breadcrumb-item"><router-link to="/adm"><span>{{$t('tlt.administration')}}</span></router-link></li> -->
                    <li class="breadcrumb-item"><router-link to="/adm/role"><span>{{$t('tlt.role')}}</span></router-link></li>
                </ul>
            </div>
            <div class="col-lg-4">
                <div class="float-lg-right">
                    <mmf-button type="add"
                                show-name                                
                                v-bind:class="'btn btn-outline-primary'"
                                v-on:click="MMFNew('role')">
                    </mmf-button>
                    <!-- <button class="btn btn-outline-primary" v-on:click="MMFNew('systemParameters')">
                        <i class="fa fa-fw fa-lg fa-plus"></i>
                        <span class="text">{{ $t("btn.basic.add") }}</span>
                    </button> -->
                </div>
            </div>
        </div>
        <section class="app-content">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div
                        id="collapseOne"
                        class="collapse show "
                        aria-labelledby="headingOne"
                        data-parent="#accordionFilter"
                        >
                        <div class="card-body">
                            <form class="row">
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.role.name") }}:
                                    </label>
                                    <input class="form-control" type="text" v-model="nameFilter"/>                            
                                </div>
                                                            
                                <div class="col-lg-10 align-self-end">
                                    <div class="float-lg-right">
                                        <button class="btn btn-outline-secondary mr-1" type="button" 
                                         v-on:click="MMFClearFilter('role')">
                                            <i class="fa fa-fw fa-lg fa-eraser"></i>
                                            <span class="text">{{ $t("btn.basic.clear") }}</span>
                                        </button>
                                        <button class="btn btn-primary" type="button" v-on:click="MMFLoadRows('role')">
                                            <i class="fa fa-fw fa-lg fa-search"></i>
                                            <span class="text">{{ $t("btn.basic.search") }}</span>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div id="role" class="content">
                <div class="card my-1">
                    <div id="collapseTwo"
                         class="collapse show"
                         aria-labelledby="headingTwo"
                         data-parent="#accordionResult">

                        <div class="card-body">
                            <mmf-table entity="role" inline-actions-disabled singleChoice>
                            </mmf-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { createHelpers } from 'vuex-map-fields';
import {gridFields, filterFields}  from "@/model/adm/Role";
import MmfTable from "@/components/MmfTable";
import MmfButton from "@/components/MmfButton";

// create a helper to generate getters and setters with namespace
const { mapFields } = createHelpers({
    getterType: 'role/getField',
    mutationType: 'role/updateField',
  });

export default {
  data () {
    return {
      currentPage: 1,
      displayedValue: "",
      perPage: 15
    }
  },
  components: { MmfTable, MmfButton },
  name: "roleList",
  computed: {
        // generate and add getters and setters using the filter names defined in
        // entity model
        ...mapFields(filterFields),
        //define the state of rows and fields of grid
        ...mapState({
            rows: state => state.role.rows,
            checkedItems: state => state.role.checkedItems,
            showNoResultAlert: state => state.base.showNoResultAlert,
            tableColumns: gridFields
        })
  },
  mounted() {
      this.$store.dispatch("role/loadAllMenus");
  },
  methods: {
    toggleAll(checked) {
        if(!checked){
            this.$store.commit( "role/checkedItems", [] );
            return;
        }

        var auxVector = []
        for (let i in this.$store.state.role.rows)
            auxVector.push(this.$store.state.role.rows[i].id)

        this.$store.commit( "role/checkedItems", auxVector );
    },
    showValue(item){
        this.displayedValue = item.value;
    },
    ...mapActions("base", ["MMFselectRow", "MMFselectAllRows", "MMFNew", 
    "MMFEdit", "MMFLoadRows", "MMFDelete", "MMFClearFilter"])
  }
};
</script>
